<template>
  <div class="core_form__item" :class="['core__item',classes,classesforDirection,classesforAlign,]" :style="itemStyles">
    <label class="core__label" :style="labelStyles" :title="label">{{label}}</label>
    <div class="core__item_content">
      <slot class="core__input"></slot>
    </div>
    <transition name="fade" class="tips">
      <div :class="['ivu-form-item-error-tip','core__item_tips']" v-if="validateState === 'error' && showMessage && form.showMessage" :style="tipStyle">{{ validateMessage }}</div>
    </transition>
  </div>
</template>
<script>
import AsyncValidator from "async-validator";

const prefixCls = "ivu-form-item";

function getPropByPath(obj, path) {
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, ".$1");
  path = path.replace(/^\./, "");

  let keyArr = path.split(".");
  let i = 0;

  for (let len = keyArr.length; i < len - 1; ++i) {
    let key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      throw new Error(
        "[iView warn]: please transfer a valid prop path to form item!"
      );
    }
  }
  let test = {
    o: tempObj,
    k: keyArr[i],
    v: tempObj[keyArr[i]]
  };

  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj[keyArr[i]]
  };
}

export default {
  name: "FormItem",
  data() {
    return {
      isRequired: false,
      validateState: "",
      validateMessage: "",
      validateDisabled: false,
      validator: {}
    };
  },
  inject: ["col", "labelWidthbyForm", "conten", "form"],
  props: {
    // label标签
    label: {
      type: String,
      default: ""
    },
    //label长度
    labelWidth: {
      type: Number
    },
    // label方向
    labelDirection:{
      validator(value) {
        let arr = ["horizontal", "vertical"];
        return arr.includes(value);
      },
      default: "horizontal"
    },
    //label文字排列
    labelAlign: {
      validator(value) {
        let arr = ["left", "right"];
        return arr.includes(value);
      },
      default: "right"
    },
    // occupy
    // occupy:{
    //   type: [Number,String]
    // },
    prop: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: [Object, Array]
    },
    error: {
      type: String
    },
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classes() {
      return [
        `core__item-${this.col}`,
        {
          [`required`]: this.required || this.isRequired,
          [`${prefixCls}-error`]: this.validateState === "error",
          [`${prefixCls}-validating`]: this.validateState === "validating"
        }
      ];
    },
    itemStyles() {
      let style = {};
      style.width = `${(100 / this.col).toFixed(3)}%`;
      return style;
    },
    labelStyles() {
      let style = {};
      const labelWidth =
        this.labelWidth === 0 || this.labelWidth
          ? this.labelWidth
          : this.labelWidthbyForm;

      if (labelWidth || labelWidth === 0) {
        style.width = `${labelWidth}px`;
      }
      return style;
    },
    //label方向
    classesforDirection() {
      if( this.labelAlign!= undefined){
        return [`label-${this.labelDirection}`];
      }
      
    },
    //label对齐方式
    classesforAlign() {
      if( this.labelAlign!= undefined){
        return [`label-${this.labelAlign}`];
      }
      
    },
    tipStyle() {
      let style = {};
      let labelWidth =
        this.labelWidth === 0 || this.labelWidth
          ? this.labelWidth
          : this.labelWidthbyForm;
      if (labelWidth || labelWidth === 0) {
        labelWidth = Number(labelWidth) + 8

        // debugger
        style.left = `${labelWidth}px`;
      }
      return style;
    },
    fieldValue() {
      const model = this.form.model;
      if (!model || !this.prop) {
        return;
      }
      let path = this.prop;
      if (path.indexOf(":") !== -1) {
        path = path.replace(/:/, ".");
      }
      return getPropByPath(model, path).v;
    },
    // testStyle(){
    //   let col = parseInt(this.col);
    //   let occupy = parseInt(this.occupy);
    //   let newCol,newOccupy,style = {};
    //   // style.width = `${(100 / this.col).toFixed(2)}%`;
    //   let width = (100 / this.col).toFixed(2);

    //   if(occupy > col){
    //     return
    //   }else{
    //     let occupyWidth0 = width * newOccupy;
    //     style.width = `${occupyWidth0}%`
    //     return style;
    //   }
    // },
    // testOccupy(){
    //   if(!this.occupy){
    //     let style={}
    //     let width = ((100 / this.col).toFixed(2)) * this.occupy
    //     style.width = `calc(100% - ${width})`
    //     return style
    //   }
    // }
    
  },
  watch: {
    error: {
      handler(val) {
        this.validateMessage = val;
        this.validateState = val ? "error" : "";
      },
      immediate: true
    },
    validateStatus(val) {
      this.validateState = val;
    },
    rules() {
      this.setRules();
    },
    // occupy:{
    //   handler(newVal,oldVal){
    //     console.log('this.form.col>>>>>>>>>>>>>',this.form.col)
    //     console.log('newVal>>>>>>>>>>>>>',newVal)
    //     console.log('oldVal>>>>>>>>>>>>>',oldVal)
    //   },
    //   immediate:true
    // }
  },
  methods: {
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    setRules() {
      let rules = this.getRules();
      if (rules.length && this.required) {
        return;
      } else if (rules.length) {
        rules.every(rule => {
          this.isRequired = rule.required;
        });
      } else if (this.required) {
        this.isRequired = this.required;
      }
      this.$off("on-form-blur", this.onFieldBlur);
      this.$off("on-form-change", this.onFieldChange);
      this.$on("on-form-blur", this.onFieldBlur);
      this.$on("on-form-change", this.onFieldChange);
    },
    getRules() {
      let formRules = this.form.rules;
      const selfRules = this.rules;

      formRules = formRules ? formRules[this.prop] : [];

      return [].concat(selfRules || formRules || []);
    },
    getFilteredRule(trigger) {
      const rules = this.getRules();

      return rules.filter(
        rule => !rule.trigger || rule.trigger.indexOf(trigger) !== -1
      );
    },
    validate(trigger, callback = function() {}) {
      let rules = this.getFilteredRule(trigger);

      if (!rules || rules.length === 0) {
        if (!this.required) {
          callback();
          return true;
        } else {
          rules = [{ required: true }];
        }
      }
      // debugger;
      this.validateState = "validating";

      let descriptor = {};
      descriptor[this.prop] = rules;
      // console.log('rules',rules)

      const validator = new AsyncValidator(descriptor);
      let model = {};

      model[this.prop] = this.fieldValue;

      validator.validate(model, { firstFields: true }, errors => {
        this.validateState = !errors ? "success" : "error";
        this.validateMessage = errors ? errors[0].message : "";

        callback(this.validateMessage);
      });
      // debugger;
      this.validateDisabled = false;
    },
    resetField() {
      this.validateState = "";
      this.validateMessage = "";

      let model = this.form.model;
      let value = this.fieldValue;
      let path = this.prop;
      if (path.indexOf(":") !== -1) {
        path = path.replace(/:/, ".");
      }

      let prop = getPropByPath(model, path);

      //                if (Array.isArray(value) && value.length > 0) {
      //                    this.validateDisabled = true;
      //                    prop.o[prop.k] = [];
      //                } else if (value !== this.initialValue) {
      //                    this.validateDisabled = true;
      //                    prop.o[prop.k] = this.initialValue;
      //                }
      if (Array.isArray(value)) {
        this.validateDisabled = true;
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        this.validateDisabled = true;
        prop.o[prop.k] = this.initialValue;
      }
    },
    onFieldBlur() {
      this.validate("blur");
    },
    onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }
    }
  },
  mounted() {
    if (this.prop) {
      this.dispatch("iForm", "on-form-item-add", this);

      Object.defineProperty(this, "initialValue", {
        value: this.fieldValue
      });

      this.setRules();
    }
  },
  beforeDestroy() {
    this.dispatch("iForm", "on-form-item-remove", this);
  }
};
</script>
<style lang="scss">
@import './form.scss';
</style>
<style>
.core_form__item .ivu-input-wrapper {
  flex: 1;
}
</style>